import { render, staticRenderFns } from "./RealInfo.vue?vue&type=template&id=765b88e6&scoped=true&"
import script from "./RealInfo.vue?vue&type=script&lang=js&"
export * from "./RealInfo.vue?vue&type=script&lang=js&"
import style0 from "./RealInfo.vue?vue&type=style&index=0&id=765b88e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765b88e6",
  null
  
)

export default component.exports